import Container from '../ui/Container';

export default function CareerHero() {
  return (
    <section className="bg-brown-50 py-16">
      <Container>
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Join Our Team, Shape Africa's Future</h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            At BNC Africa Holdings, we believe that people are our greatest asset. We are committed to creating a workplace where innovation, collaboration, and growth thrive. By joining our team, you'll be part of a vision-led organization dedicated to driving progress across industries and transforming lives throughout Africa.
          </p>
        </div>
      </Container>
    </section>
  );
}